import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import './Articles.css';
import { Article } from '../types.ts';

function Articles() {
  const navigate = useNavigate();
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const db = getFirestore();
        const articlesSnapshot = await getDocs(collection(db, 'Articles'));
        const articlesData = articlesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        } as Article));
        setArticles(articlesData);
      } catch (error) {
        console.error('Erreur lors de la récupération des articles:', error);
      }
    };

    fetchArticles();
  }, []);

  const handleDelete = async (article: Article) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet article ?')) {
      try {
        const db = getFirestore();
         
        // Supprimer l'image si elle existe
        if (article.image) {
          try {
            const storage = getStorage();
            const imageRef = ref(storage, article.image);
            await deleteObject(imageRef);
            console.log('Image supprimée avec succès');
          } catch (imageError) {
            console.error('Erreur lors de la suppression de l\'image:', imageError);
            // Continue même si la suppression de l'image échoue
          }
        }
  
        // Supprimer l'article de Firestore
        await deleteDoc(doc(db, 'Articles', article.id));
        console.log('Article supprimé avec succès');
        
        // Mettre à jour l'état local
        setArticles(articles.filter(a => a.id !== article.id));
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        alert('Erreur lors de la suppression de l\'article');
      }
    }
  };

  return (
    <div className="articles-container">
      <div className="header-actions">
        <button
          className="ajouter-btn"
          onClick={() => navigate('/mapage/ajouter-article')}
        >
          Ajouter un article
        </button>
      </div>

      <div className="articles-list">
        {articles.map((article) => (
          <div key={article.id} className="article-item">
            <div className="article-header">
              <h3>{article.titre}</h3>
              <span className="article-date">{article.date}</span>
            </div>
            
            <div className="article-content">
              {article.image && (
                <img 
                  src={article.image} 
                  alt={article.titre}
                  className={`article-image ${article.positionImage}`}
                />
              )}
              <p>{article.resume}</p>
            </div>

            <div className="article-actions">
              <button
                onClick={() => navigate(`/mapage/modifier-article/${article.id}`)}
                className="modifier-btn"
              >
                Modifier
              </button>
              <button
                onClick={() => handleDelete(article)}
                className="supprimer-btn"
              >
                Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Articles;